// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vll_q{max-height:90vh}.vll_q.Cjrqp{text-align:left}.vll_q .vRDgm{margin-bottom:2rem}.vll_q .vRDgm .bSp80{color:#ff880b;display:inline-block}.vll_q .fkqFq{width:30rem}.vll_q .IzcNO{background-repeat:no-repeat;background-size:contain;height:12rem;margin-left:1rem;position:absolute;top:-6.5rem;width:12rem}.vll_q .kLhrO{left:-.5rem;top:-4.5rem}.vll_q .kLhrO,.vll_q .MPQLd{background-repeat:no-repeat;background-size:contain;height:8rem;position:absolute;width:9rem}.vll_q .MPQLd{left:2rem;top:-5rem}.vll_q .Etf2s,.vll_q .bDFhQ{width:5rem}.vll_q .Etf2s,.vll_q .bDFhQ,.vll_q .ZN35I{background-repeat:no-repeat;background-size:contain;height:8rem;left:2rem;position:absolute;top:-5rem}.vll_q .ZN35I{width:8rem}.vll_q .IBbJN{height:7rem;left:1rem;width:7rem}.vll_q .IBbJN,.vll_q .ERjLU{background-repeat:no-repeat;background-size:contain;position:absolute;top:-5rem}.vll_q .ERjLU{height:6.5rem;left:0;width:8rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `vll_q`,
	"alignLeft": `Cjrqp`,
	"welcomeHeader": `vRDgm`,
	"version": `bSp80`,
	"robotSaucerImg": `fkqFq`,
	"robotBoxImg": `IzcNO`,
	"robotShrugImg": `kLhrO`,
	"robotTelescopeImg": `MPQLd`,
	"robotLaptopImg": `Etf2s`,
	"robotReadingImg": `bDFhQ`,
	"robotReportImg": `ZN35I`,
	"robotStig": `IBbJN`,
	"sbomImg": `ERjLU`
};
module.exports = ___CSS_LOADER_EXPORT___;
